import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { TextBox } from "../../core/components/textBox";
import { FieldInstance } from "../../core/components/field";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Helper } from "../../core/util/helper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { GetNextNumber } from "../../core/components/getNextNumber";
import { IsNumericTextBox } from "../../core/components/isNumericTextBox";
import EditTranslations from "../editTranslations";
import { ContextGeneralSettingsApp } from "../generalSettings";
import React from "react"

export default class EditFreeOfCharge extends React.Component<{ context: ContextGeneralSettingsApp }, EditFreeOfChargeState> {
    private _translations: string[] = null;
    private _options: any = null;
    private _editTranslationsRef: EditTranslations = null;
    private _factory = ComponentHelper.createFactory();
    private _fullLoaded: boolean;
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this._checkData()) {
                        this._save();
                    } else {
                        DialogHelper.alert(this._translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this._fullLoaded = false;
        this.state = { gridData: [], deleteButtonEnabled: false, dialogOpen: false, currentItem: null };
    }

    private _checkData = () => {
        return !Helper.isNullOrEmpty(this.state.currentItem.Id) && !Helper.isNullOrEmpty(this.state.currentItem.Designation);
    }

    private _getGridData = () => {
        let url = "ServiceReportSettings/GetAllFreeOfChargeKeys";
        HTTPService.get<JsonResultClass<FreeOfChargeKey[]>>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _save = () => {
        let url = "ServiceReportSettings/SaveFreeOfChargeKeys"//"ProjectSettings/SaveType";
        HTTPService.post<JsonResultClass>(url, { model: this.state.currentItem }).then(result => {
            if (result.Code == 0) {
                this._getGridData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }

    private _createDialog = () => {
        if (this.state.dialogOpen) {
            return (
                <div>
                    <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                        <FullHeightContainer>
                            {this._createIdBox()}
                            {this._createDesignationTextBox()}
                            {this._createTranslationLabel()}
                            {this._createNumericTextBox()}
                        </FullHeightContainer>
                        <EditTranslations
                            ref={(r) => this._editTranslationsRef = r}
                            label={Config.translations.editLabel}
                            saveGerman={(value: string) => {
                                let item = this.state.currentItem;
                                item.GermanDesignation = value;
                                this.setState({ currentItem: item });
                            }}
                        />
                    </Dialog>
                </div>
            );
        } else {
            return (<></>);
        }
    }



    private _createDesignationTextBox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = this.state.currentItem.Designation;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let item = this.state.currentItem;
            item.Designation = value;
            this.setState({ currentItem: item });
        }
        return (
            <FieldInstance label={this._translations["Standard.Bezeichnung"] + " *"} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _createIdBox = () => {
        if (this.state.currentItem.IsNew) {
            let props = this._factory.getDefaultNextNumberProps();
            props.value = this.state.currentItem.Id;
            props.field.url = "ServiceReportSettings/GetNextNumber";
            props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                let item = this.state.currentItem;
                item.Id = value;
                this.setState({ currentItem: item });
            }
            return (
                <FieldInstance label={this._translations["Standard.Key"] + " *"} noHover={true}>
                    <GetNextNumber {...props} />
                </FieldInstance>
            );
        } else {
            let props = this._factory.getDefaultTextBoxProps();
            props.value = this.state.currentItem.Id;
            props.disabled = true;
            return(
                <FieldInstance label={this._translations["Standard.Key"]} noHover={true}>
                    <TextBox {...props} />
                </FieldInstance>
            );
        }
    }

    private _createNumericTextBox = () => {
        let props = this._factory.getDefaultNumericTextBoxProps();
        props.value = this.state.currentItem.Discount;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            let item = this.state.currentItem;
            item.Discount = value;
            this.setState({ currentItem: item });
        }
        props.field.format = "0.00";
        props.field.decimals = 2;
        return (
            <FieldInstance label={this._translations["Field.Material.rabatt"]} noHover={true}>
                <IsNumericTextBox {...props} />
            </FieldInstance>
        );
    }

    private _createTranslationLabel = () => {
        if (!this.state.currentItem.IsNew) {
            const labelStyle: React.CSSProperties = {
                cursor: "pointer",
                textDecoration: "Underline"
            }
            const divStyle: React.CSSProperties = {
                display: "flex",
                justifyContent: "flex-end",
                fontSize: "10px",
                marginTop: "2px"
            }
            return (
                <FieldInstance noLabel={true}>
                    <div style={divStyle}>
                        <label
                            style={labelStyle}
                            onClick={this._openTranslationsDialog}>{this.props.context.translations["WebSMS.GeneralSettings.UebersetzungenBearbeiten"]}
                        </label>
                    </div>
                </FieldInstance>);
        } else {
            return <></>;
        }
    }

    private _openTranslationsDialog = () => {
        this._editTranslationsRef.openDialog(this.state.currentItem.IsRowId, 220, "value_0", this.state.currentItem.GermanDesignation);
    }

    private _delete = (dataItem: FreeOfChargeKey) => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let url = "ServiceReportSettings/DeleteFreeOfChargeKey";
                HTTPService.post<JsonResultClass>(url, { model: dataItem }).then(result => {
                    if (result.Code == 0) {
                        this._getGridData();
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
            }
        });
    }

    private _openDialog = (dataItem: FreeOfChargeKey = null) => {
        if (!Helper.hasValue(dataItem)) {
            dataItem = {
                Id: "",
                Designation: "",
                GermanDesignation: "",
                Discount: 0,
                IsRowId: 0,
                IsDeleteable: true,
                IsNew: true,
            };
        }
        this.setState({ dialogOpen: true, currentItem: { ...dataItem } })
    }

    private _createGrid = () => {

        if (this._fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.deleteButtonEnabled });
            let grid = (
                <Grid data={this.state.gridData} options={this._options} id="generalSettings_FreeOfChargeKeysGrid" onSelectionChanged={this._handleSelectedChange}
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private _handleSelectedChange = (dataItem: FreeOfChargeKey) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ deleteButtonEnabled: dataItem.IsDeleteable });
        }
        else
            this.setState({ deleteButtonEnabled: false });
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: FreeOfChargeKey) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this._openDialog(dataItem)
                break;
            case (ToolBarStandardButtonType.NEW):
                this._openDialog()
                break;
            case (ToolBarStandardButtonType.DELETE):
                this._delete(dataItem);
                break;
        }
    }

    componentDidMount() {
        this._translations = this.props.context.translations;
        this._options = this.props.context.freeOfChargeKeyGridOptions;
        this._fullLoaded = true;
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        const dialog = this._createDialog();
        return (
            <>
                {grid}
                {dialog}
            </>);
    }
};


interface EditFreeOfChargeState {
    dialogOpen: boolean;
    deleteButtonEnabled: boolean;
    currentItem: FreeOfChargeKey;
    gridData: FreeOfChargeKey[];
}

interface FreeOfChargeKey {
    Id: string;    
    Designation: string;
    GermanDesignation: string;
    Discount: number;
    IsRowId: number;
    IsNew: boolean;
    IsDeleteable: boolean;
}